export default __webpack_public_path__ + "static/heroBg-3d114971977194406a0b3d5ab9f219cf.png";